import {
    ButtonConnection, ContainerConnection,
    ContentConnectionStatus, ContentImageApproved,
    ContentTextStatus,
    TextConnectionStatus
} from "@dropDesk/presentation/pages/company_configurations/ui/whatsapp_configuration/connection/status_whatsapp/styled";
import React from "react";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {SharedColors} from "@dropDesk/domain/entities/theme/app_colors";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import DropDeskIcon from "@dropDesk/storage/icons";
import {SpinLoading} from "@dropDesk/presentation/components/loadings/spin";

const ImageStatus = (
    {
        status,
        imageUrl,
        textButton,
        isDisconnected,
        isReconnecting,
        disabled,
        onClickButton,
        loading
    }: {
        status: string
        imageUrl: string | null
        textButton: string
        isDisconnected?: boolean
        isReconnecting?: boolean
        disabled?: boolean
        loading: boolean
        onClickButton?: () => void
    }) => {
    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    const getStatusColor = (): string => {
        if (isDisconnected || isReconnecting) {
            return colors.accent;
        }
        return colors.textError;
    }

    const getTextLoading = (): React.ReactNode => {
        if (loading) {
            return (
                <TextConnectionStatus color={colors.text}>&nbsp;Carregando...</TextConnectionStatus>
            )

        } else {
            return (
                <TextConnectionStatus
                    style={{fontWeight: 'bold'}}
                    color={getStatusColor()}>&nbsp;{status}</TextConnectionStatus>
            )
        }

    }

    const renderStatusIcon = (): React.ReactNode => {
        if (isReconnecting) {
            return (
                <SpinLoading
                    size={"large"}
                    color={colors.accent}
                />
            )
        }
        if (imageUrl) {
            return (
                <DropDeskIcon style={{display: 'flex'}} icon={ICONS_DROPDESK.whatsapp} size={106}
                              color={colors.hintInverse}/>
            )
        }
        return (
            <DropDeskIcon style={{display: 'flex'}} icon={ICONS_DROPDESK.check} size={106}
                          color={colors.success}/>
        )
    }

    return (
        <ContainerConnection>
            <ContentTextStatus>
                <TextConnectionStatus color={colors.text}>Status:</TextConnectionStatus>
                {getTextLoading()}
            </ContentTextStatus>

            <ContentConnectionStatus>
                <ContentImageApproved
                    border={colors.border}
                    background={colors.onBackground}>
                    {renderStatusIcon()}
                </ContentImageApproved>
                <ButtonConnection
                    onClick={() => {
                        if (disabled || !onClickButton) {
                            return;
                        }
                        onClickButton();
                    }}
                    disabled={disabled}
                    background={isDisconnected ? colors.errorOnPrimary : colors.accent}
                    color={SharedColors.white}>
                    {loading ? 'Carregando' : textButton}
                </ButtonConnection>
            </ContentConnectionStatus>
        </ContainerConnection>
    )
}
export default ImageStatus;
